import React from 'react';
import Contact from '../components/Contact';
import SEO from '../components/SEO';

const ContactPage = () => {
  return (
    <>
      <SEO
        title="İletişim"
        description="LYSEP CORPORATION ile iletişime geçin. Projeleriniz için profesyonel çözümler sunuyoruz. Form doldurun veya e-posta gönderin. Hızlı ve güvenilir hizmet."
        keywords="LYSEP iletişim, yazılım hizmeti, teknoloji danışmanlığı, proje teklifi, iletişim formu, info@lysep.com, support@lysep.com"
        path="/contact"
      />
      <Contact />
    </>
  );
};

export default ContactPage;

